import React from 'react';
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { useAuth } from '../../auth';

export const RequireInternal: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const auth = useAuth();
  const navigate = useNavigate();

  if (auth.isLoading) {
    return <CircularProgress />;
  }

  if (!auth.user) {
    navigate('/login', { replace: true });
    return;
  }

  if (!auth.user.internal_role) {
    const accountName = auth.user.roles[0]?.account?.name;
    navigate(accountName ? `/${accountName}/flows` : '/login', {
      replace: true,
    });
    return;
  }

  return children;
};
